import { CircularProgress, Container, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import dataService from '../services/dataService'
import DateChooser from '../components/DateChooser'
import GraphDisplay from './GraphDisplay'
import moment from 'moment'
import { connect } from 'react-redux'
import { setStart } from '../reducers/StartDateReducer'
import { setEnd } from '../reducers/EndDateReducer'
import { setNotification } from '../reducers/NotificationReducer'
import { setData } from '../reducers/dataReducer'
import axios from 'axios'
import DataCard from './DataCard'
var XMLParser = require('react-xml-parser')
import { createGlobalStyle } from 'styled-components'
import img2 from '../assets/Smarctic2.jpg'
import FadeIn from 'react-fade-in/lib/FadeIn'


const GlobalStyle = createGlobalStyle`
  body {
    background: url(${img2}) no-repeat;
    background-color: #000000;
    background-attachment: fixed;
    margin-bottom: 100px;
    background-size: 100%;
  }
`

const PilotSiteOunas = (props) => {
  const [ sensor, setSensor ] = useState('')
  const [ outDoor, setOutdoor ] = useState('')
  const [ indoor, setIndoor ] = useState('')
  const [ outdoorHistory, setOutdoorHistory ] = useState([])

  // useEffect-hookki, joka hakee säätiedot yr.no-rajapinnasta ja sisäilma-anturit cloudant-tietokannasta
  useEffect(() => {
    const fetchOutdoor = () => {
      try {
        axios.get('https://api.met.no/weatherapi/locationforecast/2.0/compact?altitude=203&lat=66.50059755034759&lon=25.80012857800576')
          .then(r => {
            setOutdoor(r.data.properties.timeseries)
          })
      } catch (e) {
        console.log(e)
      }
    }

    const fetchIndoor = async () => {
      try {
        let today = new Date().getTime()
        let d = new Date()
        let yesterday = d.setDate(d.getDate() - 1)
        const data = await dataService.getIndoor1({
          url: 'sisailma1', formatStart: yesterday, formatEnd: today
        })
        const sortData = data.docs.sort((a, b) => b.Timestamp - a.Timestamp)
        setIndoor(sortData)
      } catch (e) {
        console.log(e)
      }
    }

    fetchOutdoor()
    fetchIndoor()
  }, [])

  /*
  const parseXml = (xml, name) => {
    const array = xml.map(o => o.filter(j => j.name === name).map(v => v.value))
    return array.flat()
  }
  */


  // Haetaan säätiedot historiadatana ilmatieteen laitoksen sivuilta
  // Tulos palautetaan xml-muodossa ja se parsitaan jsoniksi XMLParserilla
  const fetchOutdoorHistory = (start, end) => {
    try {
      /* try {
      axios.get(`https://opendata.fmi.fi/wfs/fin?service=WFS&version=2.0.0&request=getFeature&storedquery_id=fmi::observations::weather::hourly::timevaluepair&fmisid=101920&starttime=${start}&endtime=${end}`)
        .then(r => {
          const xml = new XMLParser().parseFromString(r.data)
          const xmlChildren = xml.getElementsByTagName('wml2:MeasurementTVP').map(m => m.children)
          console.log(xmlChildren)

          console.log('Values: ', parseXml(xmlChildren, 'wml2:value'))
          console.log('Timestamps: ', parseXml(xmlChildren, 'wml2:time'))

          const obj = {
            y: parseXml(xmlChildren, 'wml2:value'),
            x: parseXml(xmlChildren, 'wml2:time').map(o => moment(o).format('HH D.M.YYYY'))
          }
          console.log('Objekti: ',obj)
          setOutdoorHistory(obj)
        })
      }*/
      axios.get(`https://opendata.fmi.fi/wfs/fin?service=WFS&version=2.0.0&request=getFeature&storedquery_id=fmi::observations::weather::hourly::simple&fmisid=101920&starttime=${start}&endtime=${end}&parameters=TA_PT1H_AVG`)
        .then(r => {
          const xml = new XMLParser().parseFromString(r.data)
          const xmlTime = xml.getElementsByTagName('BsWfs:Time')
          const xmlValue = xml.getElementsByTagName('BsWfs:ParameterValue')
          console.log('Time: ', xmlTime.map(t => t.value))
          console.log('value: ', xmlValue.map(t => t.value))

          const obj = {
            x: xmlTime.map(t => t.value).map(o => moment(o).format('HH D.M.YYYY')),
            y: xmlValue.map(t => t.value)
          }
          setOutdoorHistory(obj)
        })
    }
    catch (e) {
      console.log(e)
    }
  }

  // Event-funktio, joka kutsuu sisä- ja ulkolämpötilojen rajapintoja ja tietokantoja
  const handleSubmit = async (event) => {
    event.preventDefault()
    if (props.start !== null && props.end !== null) {
      const formatStart = props.start.getTime()
      const formatEnd = props.end.getTime()
      try {
        props.setNotification('Searching from database...')
        let url = sensor.service
        const data = await dataService.getIndoor1({
          url, formatStart, formatEnd
        })
        const iterData = data.docs
        console.log(data.docs)
        const sortedIteratedData = iterData.sort((a, b) => a.Timestamp - b.Timestamp)
        const formatIndoorTimestamp = sortedIteratedData.map(m => {
          const formatTs = new Date(m.Timestamp)
          return {
            ID: m._id,
            Timestamp: moment(formatTs).format('HH D.M.YYYY'),
            Temperature: m.Measurements.temperature_1.toString(),
            Humidity: m.Measurements.humidity_1.toString(),
            AirPressure: m.Measurements.pressure_1.toString(),
            VOC: m.Measurements.voc_1.toString(),
            Luminance: m.Measurements.illumination_1.toString()
          }
        })
        fetchOutdoorHistory(props.start.toISOString(), props.end.toISOString())
        props.setData(formatIndoorTimestamp)
        props.setNotification('')
      } catch (exception) {
        console.log(exception)
        console.log('Error happened with async req')
      }
    }
  }


  return (
    <FadeIn transitionDuration="3000">
      <Container>
        <React.Fragment>
          <GlobalStyle  />
        </React.Fragment>
        <Typography variant="h3" style={{ color:'white' }}>Pilot Site Ounashalli</Typography>
        {
          outDoor && indoor ?
            <div className="grid-container">
              <DataCard name="Outdoor Temperature" value={`${outDoor[0].data.instant.details.air_temperature}°C`} />
              <DataCard name="Indoor Temperature" value={`${indoor[0].Measurements.temperature_1}°C`} />
              <DataCard name="Indoor Humidity" value={`${indoor[0].Measurements.humidity_1} %`} />
              <DataCard name="Indoor VOC" value={`${indoor[0].Measurements.voc_1} IAQ`} />
            </div>
            : <CircularProgress />
        }
        <div>
          <DateChooser handleSubmit={handleSubmit} sensor={sensor} setSensor={setSensor} />
          {
            props.data && outdoorHistory ?
              <div>
                <GraphDisplay
                  dataX={props.data.map(d => d.Timestamp)}
                  dataY={props.data.map(d => d.Temperature)}
                  dataX2={outdoorHistory.x}
                  dataY2={outdoorHistory.y}
                  title="Temperature - Combined Indoor and Outdoors"
                />
              </div> : <p></p>
          }
          {
            props.data ?
              <div>
                <GraphDisplay
                  dataX={props.data.map(d => d.Timestamp)}
                  dataY={props.data.map(d => d.Temperature)}
                  title="Temperature"
                />
                <GraphDisplay
                  dataX={props.data.map(d => d.Timestamp)}
                  dataY={props.data.map(d => d.Humidity)}
                  title="Humidity"
                />
                <GraphDisplay
                  dataX={props.data.map(d => d.Timestamp)}
                  dataY={props.data.map(d => d.VOC)}
                  title="VOC"
                />
              </div> : <p></p>
          }
          <div>
            {
              outdoorHistory.length > 0 ?
                <GraphDisplay
                  dataX={outdoorHistory.x}
                  dataY={outdoorHistory.y}
                  title="Outdoor Weather"
                /> : <p></p>
            }
          </div>
        </div>
        <div>
          {
            outdoorHistory ?
              <Typography style={{ color:'white' }}></Typography> : <Typography>Error</Typography>
          }
        </div>
      </Container>
    </FadeIn>
  )
}

const mapStateToProps = (state) => {
  return {
    notification: state.notification,
    start: state.start,
    end: state.end,
    data: state.data
  }
}

const mapDispatchToProps = {
  setNotification,
  setStart,
  setEnd,
  setData
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PilotSiteOunas)